import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { LivretEleveDiff } from '../LivretEval/LivretEleve/components/LivretEleve/SyncLivret/types';

interface Props {
  livretEleveId: string;
}

function getLivretElevesDiff({
  schoolyearId,
  schoolId,
  livretEleveId,
}: {
  schoolyearId: string;
  schoolId: string;
  livretEleveId: string;
}): Promise<LivretEleveDiff[]> {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livret-eleves/${livretEleveId}/diff`;
  return request(requestURL, {
    method: 'GET',
  }).then(({ data }) => data || []);
}

export function useLivretEleveDiff({ livretEleveId }: Props) {
  const { schoolyear, school } = useSchoolSchoolyear();
  return useQuery({
    queryKey: ['LIVRET_ELEVE_DIFF', schoolyear.id, school.id, livretEleveId],
    queryFn: () =>
      getLivretElevesDiff({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        livretEleveId: livretEleveId,
      }),

    refetchOnWindowFocus: true,
  });
}
